// extracted by mini-css-extract-plugin
export default {"your_rd":"Uv","title":"Vv","subtitle":"Wv","rd_bio_wrapper":"Xv","rd_text_mobile":"Yv","rd_bio":"Zv","img":"aw","rd_info":"bw","rd_name":"cw","rd_stat":"ew","rd_text":"fw","btn_mobile":"gw"};
    if(module.hot) {
      // 1743628922773
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  